/**
 * TabBar — Abas horizontais dark theme com ícone por tab
 * Suporta variant "underline" (padrão) e "pill" (fundo com gradiente)
 */
import { T, CT } from '../../styles/tokens';

interface TabBarProps {
  tabs: { id: string; label: string; badge?: number; icon?: any }[];
  active: string;
  onChange: (id: string) => void;
  /** 'underline' (padrão) ou 'pill' (fundo com gradiente) */
  variant?: 'underline' | 'pill';
}

export function TabBar({ tabs, active, onChange, variant = 'underline' }: TabBarProps) {
  if (variant === 'pill') {
    return (
      <div style={{
        display: 'flex', gap: 4, marginBottom: 16, padding: 4,
        background: T.bgCard, borderRadius: 12,
        border: `1px solid ${T.border}`,
      }}>
        {tabs.map(tab => {
          const isActive = tab.id === active;
          return (
            <button
              key={tab.id}
              onClick={() => onChange(tab.id)}
              style={{
                flex: 1, padding: '10px 8px', borderRadius: 10, border: 'none',
                background: isActive ? `linear-gradient(135deg, ${T.primary}, ${T.accent})` : 'transparent',
                color: isActive ? '#fff' : T.textMuted,
                fontSize: 12, fontWeight: 700, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4,
                transition: `all ${T.transitionFast}`,
                ...(isActive ? { boxShadow: `0 2px 8px ${T.primaryBg}` } : {}),
              }}
            >
              {tab.icon && <span>{tab.icon}</span>}
              {tab.label}
              {tab.badge != null && tab.badge > 0 && (
                <span style={{
                  background: T.danger, color: T.text, fontSize: 10,
                  fontWeight: T.weightBold, borderRadius: 10, padding: '1px 6px',
                  minWidth: 16, textAlign: 'center',
                }}>{tab.badge}</span>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', gap: 0,
      borderBottom: `1px solid ${T.border}`,
      marginBottom: T.space5,
    }}>
      {tabs.map(tab => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              padding: '10px 18px',
              fontSize: CT.tab.fontSize,
              fontWeight: isActive ? T.weightSemibold : T.weightMedium,
              color: isActive ? CT.tab.textActive : CT.tab.text,
              background: 'none',
              border: 'none',
              borderBottom: isActive ? `2px solid ${CT.tab.indicator}` : '2px solid transparent',
              cursor: 'pointer',
              transition: `all ${T.transitionFast}`,
              display: 'flex', alignItems: 'center', gap: 6,
              marginBottom: -1,
            }}
          >
            {tab.icon && <span style={{ display: 'flex', alignItems: 'center' }}>{tab.icon}</span>}
            {tab.label}
            {tab.badge != null && tab.badge > 0 && (
              <span style={{
                background: T.danger,
                color: T.text,
                fontSize: 10,
                fontWeight: T.weightBold,
                borderRadius: 10,
                padding: '1px 6px',
                minWidth: 16,
                textAlign: 'center',
              }}>
                {tab.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
